import angular from 'angular';
import uiRouter from 'angular-ui-router';
import presseticketcodeComponent from './presseticketcode.component';

let presseticketcodeModule = angular.module('presseticketcode', [
  uiRouter
])

  .component('presseticketcode', presseticketcodeComponent)

.name;

export default presseticketcodeModule;



// WEBPACK FOOTER //
// ./client/app/common/forms/presseticketcode/presseticketcode.js